module.exports = __webpack_public_path__ + "d9fb9a8c7cd57ee1f9401f778b40a123.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2100_teaser_image.jpg
// module id = 598
// module chunks = 0